<template>
<div>
 <modal :name="`${SelectdstateCode}confirm-edit-modal`"  height="auto" :scrollable="true" focusTrap:true >
      <Trap>
        <div class="breakdown-modal-top pt-3 pb-2 pl-3 pr-2 text-white bg-header-auto" >
          <h3 class="breakdown-modal-header">Confirm: Save Login Information</h3>
          <a href="JavaScript:void(0);" @click.prevent="$modal.hide(SelectdstateCode+'confirm-edit-modal')"
            class="cursorBox fa-stack uniform-icon-breakdown">
            <span class="fas fa-circle fa-stack-2x" style="color:#fff"></span>
            <span class="fas fa-times fa-stack-1x" style="color:#1C3664"></span>
          </a>
        </div>
        <p class="px-3 mt-2 confirm-modal-content mb-4">Saving carrier login credentials will affect the ability to make successful rate calls to this carrier. Please make sure the login credentials are accurate before saving.</p>
          <div class="buttons mb-4">
            <button type="button" id="confirm-cancel-button"
              class="btn btn-primary d-block ml-12 " v-on:click="closeModal()">Cancel</button>
            <button type="button" id="confirm-submit-button"
              class="btn btn-primary d-block mr-12" v-on:click="saveMe()">Save</button>
          </div>
        </Trap>
    </modal>
    </div>
</template>
<script>
/* eslint-disable */
import Trap from 'vue-focus-lock';
export default {
 props:{OpenModal:false,form:{},SelectdstateCode:''},
 components:{Trap},
  data() {
    return {
      dataToSave: {
        username: '',
        newPassword: '',
        stateCode:'',
       },
        dataToSave2: {
        username2: '',
        newPassword2: '',
       }
   
    };
  },
  methods: {
    OpenConfirmmodal() {
      Object.assign(this.dataToSave, this.form);
      this.dataToSave.stateCode=this.SelectdstateCode;
    //  console.log('before show modal : dataToSave : ',this.dataToSave);
      this.$modal.show(this.SelectdstateCode+'confirm-edit-modal');
      this.$store.commit('updateStateLoginUpdate', this.dataToSave); 
    },
    saveMe() {
      this.$emit("OpenConfirmmodal",'true');
    },
    closeModal(){
     this.$emit("closeModal",'true');
    // this.$modal.hide(this.SelectdstateCode+'confirm-edit-modal');
    //  this.OpenModal=false;
    }
  },
  watch:{
      'OpenModal':function(){
        if(this.OpenModal==true)
          this.OpenConfirmmodal();
      }
  }
};
</script>
<style>
 .noPaddingclass{
  padding-right:0px !important;
  padding-left:0px !important;
}
.buttons {
    display: flex;
    justify-content: space-between;
  }

  P.confirm-modal-content {
    font-weight: 600;
    color: #1A1A1A;
    font-size: 14px;
  }
  
  #confirm-submit-button,#confirm-submit-button:focus {
    background-color: #2E7B32 !important;
    color: #fff !important;
    border-color: #2E7B32 !important;
  }

  #confirm-submit-button:hover {
    background-color: #fff !important;
    color: #2E7B32 !important;
  }

  #confirm-cancel-button {
    background-color: #fff;
    color: #999;
    border-color: #999;
  }

 #confirm-cancel-button:hover, #confirm-cancel-button:focus,#confirm-cancel-button:focus {
    background-color: #999 !important;
    color: #fff !important;
  }
.breakdown-modal-header {
  display: inline-block;
}

.uniform-icon-breakdown {
  font-size: .7rem;
  float: right;
}
div.breakdown-modal-top h3 {
  font-size: 1rem;
  font-weight: bold;
}

.bg-header-auto {
  background-color: #2D374C !important;
}
.btn{
  text-transform: unset !important;
}
.credentials {
  display: flex;
  align-items: center;
 
}
.errorsection {
  height: 25px;
}
 .credentials LABEL {
    display: inline-flex;
    font-size: 12px;
    font-weight: 600;
  }
.password-field {
  display:-webkit-box;;
  align-items: center;
}
.text-error-msg {
  font-size: 12px;
  color: #BB0000;
  font-weight: 400;
}
.revealer {
  position: relative !important;
  left: -30px !important;
 
}
.ac-carrier-container {
  display:flex;
  align-items:center;
}
img.img-fluid{
  max-width: 180px;
  height: inherit !important;
}
.mr-12
 {
  margin-right: 12rem !important;
}
.ml-12 {
  margin-left: 10rem !important;
}
@media (min-width: 1200px) {
  .fieldset-width {
    width: 18%;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .fieldset-width {
    width: 30%;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .fieldset-width {
    width: 29.5%;
  }
}

@media (min-width: 576px) and (max-width: 767px) {
  .fieldset-width {
    width: 44%;
  }
}

@media (max-width: 575px) {
  .fieldset-width {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/interactive/confirmModal.vue?5e5ff956